const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '多层安全防护体系，数据加密传输，全方位保障您的信息安全与隐私。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '高效便捷',
    description: '智能化的操作流程设计，让复杂任务变得简单快捷，大幅提升工作效率。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能驱动',
    description: '先进的AI算法引擎，为您提供精准的智能推荐与数据分析服务。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步',
    description: '支持Web、移动端等多平台无缝切换，数据实时同步，随时随地高效办公。',
  },
  {
    icon: 'ri-team-line',
    title: '协同办公',
    description: '强大的团队协作功能，文档共享、实时编辑、任务管理一气呵成。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专业服务',
    description: '7x24小时客户支持团队，随时为您解决使用中的任何问题与疑惑。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            为什么选择 <span className="text-primary-600">开云</span>
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            六大核心优势，为您打造卓越的平台体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}